import { QuoteRecipientsType } from 'data/types';
import { useCallback, useEffect, useState } from 'react';
import {
  emptyQuoteRecipients,
  validateQuoteRecipientDraft,
  validateQuoteRecipients
} from 'utils/quote-recipients';

export function useQuoteRecipients(open: boolean) {
  const [recipients, setRecipients] =
    useState<QuoteRecipientsType>(emptyQuoteRecipients);
  const [draft, setDraft] = useState<QuoteRecipientsType>(emptyQuoteRecipients);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setRecipients(emptyQuoteRecipients);
    setDraft(emptyQuoteRecipients);
    setError(null);
  }, [open]);

  const handleEmailChange = useCallback((email: string) => {
    setRecipients((current) => ({ ...current, email }));
    setError(null);
  }, []);

  const handlePhoneNumberChange = useCallback((phoneNumber: string) => {
    setRecipients((current) => ({ ...current, phoneNumber }));
    setError(null);
  }, []);

  const handleEmailInputChange = useCallback((email: string) => {
    setDraft((current) => ({ ...current, email }));
    setError(null);
  }, []);

  const handlePhoneNumberInputChange = useCallback((phoneNumber: string) => {
    setDraft((current) => ({ ...current, phoneNumber }));
    setError(null);
  }, []);

  const validate = useCallback((): boolean => {
    const validationError =
      validateQuoteRecipientDraft(draft) ?? validateQuoteRecipients(recipients);
    setError(validationError);
    return validationError === null;
  }, [draft, recipients]);

  return {
    recipients,
    draft,
    error,
    handleEmailChange,
    handlePhoneNumberChange,
    handleEmailInputChange,
    handlePhoneNumberInputChange,
    validate
  };
}
